import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';

const MainPageStepsSectionContainer = styled.div`
  margin-top: 2.375rem;

  ${media.w.min.px576(css`
    margin-top: 3.875rem;
  `)};
`;

export default MainPageStepsSectionContainer;
